import { render, staticRenderFns } from "./PromotionSimpleTextCondition.vue?vue&type=template&id=83245d5c&"
import script from "./PromotionSimpleTextCondition.vue?vue&type=script&lang=ts&"
export * from "./PromotionSimpleTextCondition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports